import { useMemo, useState } from "react";

import TheListResource from "Components/Common/Component/resource/TheListResource";
import { useCrudApi } from "hook/useCrudApi";
import { useResourceNavigate } from "hook/useResourceNavigate";
import { useActionsCell, useTableColumns } from "hook/useTableColumns";
import { HoSoViPham } from "models/ho-so-vi-pham";
import { toast } from "react-toastify";
import { Input } from "reactstrap";
import { parent, title, useListTableColumns } from "./constant";

export const ListPage = () => {
  const { toDetail, toEdit } = useResourceNavigate();
  const { usePaginationQuery, useSearch, useDelete } =
    useCrudApi<HoSoViPham>("HoSoViPham");

  const usePaginationReturn = usePaginationQuery(1, 10);
  const { page, pageSize } = usePaginationReturn;

  const [searchKeyword, setSearchKeyword] = useState("");
  const { data, refetch } = useSearch(
    searchKeyword,
    { page, pageSize },
    {
      enabled: true,
    }
  );

  const { mutate } = useDelete({
    onSuccess: () => {
      refetch();
      toast.success(`Xóa thành công`);
    },
    onError: (error) => {
      toast.error(`Lỗi: ${error.message}`);
    },
  });

  const onDelete = async (rowId: string) => {
    mutate(rowId);
  };

  const { actionColumns } = useActionsCell({
    onView: toDetail,
    onEdit: toEdit,
    onDelete,
  });

  const { tableColumns } = useListTableColumns();

  const { columns } = useTableColumns({
    columns: tableColumns,
  });

  const tableColumnsComp = useMemo(
    () => [...columns, ...actionColumns],
    [actionColumns, columns]
  );

  return (
    <TheListResource
      {...usePaginationReturn}
      title={title}
      parent={parent}
      dataSource={data?.data || []}
      totalRows={data?.totalRecord}
      tableColumns={tableColumnsComp}
      Filter={
        <>
          <Input
            className="w-[200px]"
            placeholder="Tìm kiếm ..."
            onChange={(e) => setSearchKeyword(e.target.value)}
          />
        </>
      }
    />
  );
};
